import { useCallback, useEffect, useState } from 'react'

import { api } from 'app/api'
import { GET_COMPENSATION_BALANCE, convertResult, convertParams } from 'app/common/api/requests/cabinet/compensation/balance/get'


type Options = {
  studentID: string
  supplierID: string | null
}

export function useCompensationBanace(options: Options) {
  const { studentID, supplierID } = options
  const [balance, setBalance] = useState<number>(0)
  const [loading, setLoading] = useState(true)

  const request = useCallback(async () => {
    setLoading(true)
    const res = await api.request(GET_COMPENSATION_BALANCE, {
      error: 'Не удалось получить баланс учащегося по компенсациям',
      params: {
        studentID,
        supplierID: supplierID ?? '',
      },
      convertions: {
        convertParams,
        convertResult,
      },
    })

    setLoading(false)
    if (res) {
      setBalance(res.balance)
    }
  }, [studentID, supplierID])

  useEffect(() => {
    if (supplierID) {
      request()
    }
  }, [request, supplierID])


  return {
    balance,
    loading,
  }
}
